import { Address } from 'viem';

export enum RedeemStatus {
  Pending,
  Accepted,
  Canceled,
}

export type RedeemDataTypes = {
  uuid: bigint;
  timestamp: bigint;
  seller: Address;
  amountNfts: bigint;
  totalSellPrice: bigint;
  status: RedeemStatus;
};
